import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { Controller } from 'react-hook-form';
import { Form } from 'react-bootstrap';
import { startCase } from 'lodash';
import moment from 'moment';
import { DATE_APP_FORMAT, DATE_MOMENT_FORMAT } from 'utils/constants';

const FormDatePicker = (props) => {
  const {
    name,
    control,
    renderMessage,
    label = startCase(name),
    onChange: handleChange = (value) => value,
    md,
    as,
    tooltip,
    ...rest
  } = props;

  return (
    <Form.Group as={as} md={md} >
      <Form.Label>{label}</Form.Label>
      <div className="edit-mode" {...tooltip}>
        <Controller
          {...{ name, control }}
          valueName="selected"
          render={({ onChange, value }) => (
            <DatePicker
              dateFormat={DATE_APP_FORMAT}
              isClearable
              customInput={<Form.Control autoComplete="off" />}
              closeButton
              autoComplete="off"
              showYearDropdown
              showMonthDropdown
              yearDropdownItemNumber={5}
              wrapperClassName="w-100"
              selected={value}
              onChange={value => onChange(handleChange(value))}
              {...rest}
            />
          )}
        />
      </div>
      <div className="view-mode">
        {rest.display ? moment(rest.display).format(DATE_MOMENT_FORMAT) : '-'}
      </div>

      {renderMessage(name)}
    </Form.Group>
  );
};

FormDatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  renderMessage: PropTypes.func.isRequired,
};

export default FormDatePicker;
